const SolicitacaoAcompanhamentoClinicoOptions = [
  { id: 14, text: "Médico principal", value: "MedicoPrincipal" },
  { id: 15, text: "Médico Interconsultor", value: "MedicInterconsultor" },
];

export { SolicitacaoAcompanhamentoClinicoOptions };
